import React from 'react';

const Button = ({content, style}) => {
    return (
        <button className={`bg-[#102343] text-white flex items-center justify-center px-4 py-2 rounded ${style}`}>
            {content}
        </button>
    );
}

export default Button;
